/**
 * Stub for @devvit/web/client when building for standalone (no Reddit).
 * Use this via Vite alias when BUILD_STANDALONE=1 so the splash works without devvit.
 */

export function navigateTo(url: string): void {
  window.location.href = url;
}

export function requestExpandedMode(e: Event, pathOrTarget: string): void {
  (e as MouseEvent).preventDefault?.();
  const target = pathOrTarget === 'game' ? 'game.html' : pathOrTarget;
  window.location.href = target;
}
